module.exports = __webpack_public_path__ + "static/media/no-section-selected.b1e98a22.png";